import * as React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import 'components/MainHeader/styles.scss';
import { HamburgerMenuType } from 'utils/types';
import { titleCase } from 'utils/functions';
import FeatureToggle from 'utils/feature-toggle-utils';
import HamburgerMenu from 'components/HamburgerMenu';
import { NotificationCenter } from '@spins/notification-manager-ui';
import { UserData } from '@spins/react-sso-provider';
import { initPendo, PendoConfig } from 'utils/pendoInit';

interface Props {
  changeBrandLabel: string;
  currentBrandName: string;
  items: Array<HamburgerMenuType>;
  userInfo: UserData;
  onChangeBrand(): void;
  onLogout(): void;
}

const MainHeader: React.FC<Props> = ({
  changeBrandLabel,
  currentBrandName,
  items,
  userInfo,
  onChangeBrand,
  onLogout
}) => {
  if (FeatureToggle.isFeatureEnabled(FeatureToggle.FEATURES.PENDO)) {
    const pendoParams: PendoConfig = {
      visitor: {
        id: userInfo?.email || ''
      },
      account: {
        id: currentBrandName ? currentBrandName : ''
      }
    };

    initPendo(pendoParams);
  }

  let name = '';
  if (userInfo !== null) {
    name = `${userInfo.firstName} ${userInfo.lastName} (${titleCase(currentBrandName)})`;
  }
  return (
    <div className="main-header">
      <div className="hamburger-menu-container">
        <HamburgerMenu items={items} />
      </div>
      <div className="destini-logo">
        <span className="icon-destiniLogo" />
      </div>
      <div className="project-name">signals</div>
      <div className="notification-menu-container">
        {FeatureToggle.isFeatureEnabled(FeatureToggle.FEATURES.NOTIFICATIONS) && (
          <NotificationCenter
            apiKey={process.env.REACT_APP_NOTIFICATION_CENTER_API_KEY}
            url={process.env.REACT_APP_NOTIFICATION_CENTER_API_ENDPOINT}
            limit={process.env.REACT_APP_NOTIFICATION_CENTER_LIMIT}
            sinceDaysAgo={process.env.REACT_APP_NOTIFICATION_CENTER_MAX_DAYS}
            targetApp={process.env.REACT_APP_NOTIFICATION_CENTER_APP_NAME}
            userId={userInfo.email}
          />
        )}
      </div>
      <div className="dropdown-container">
        <DropdownButton id="main-header-dropdown" title={name}>
          <Dropdown.Item className="dropdown-item" onSelect={onChangeBrand}>
            {changeBrandLabel}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item className="dropdown-item" onSelect={onLogout}>
            Log out
          </Dropdown.Item>
        </DropdownButton>
      </div>
    </div>
  );
};

export default MainHeader;
